import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead } from "../../../../components/Components";
import { SelectObjectRemoveInterface }
    from "../../../../interfaces";
import { useRef, useState } from "react";
import { getUuidV4, goToFocus } from "../../../../utils/utils";
import { useQuestion } from "../../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../../components/ModalMessage/useModalMessage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDoorClosed } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../app/store";
import {
    addLacreUnidadeCargaUnidadeTransporteNFe, removeLacreUnidadeCargaUnidadeTransporteNFe,
    removeLacreUnidadeCargaUnidadeTransporteNFeTodos
} from "../../../../features/manifestoSlice";
interface formProps {
    id: number | string;
    idUndCarga: number | string;
    idNFe: number | string;
    show: boolean;
    handleClose: () => void;
}

const NFesUnidadeTranspUnidadeCargaLacres: React.FC<formProps> = ({ id, idUndCarga, idNFe, show, handleClose }) => {
    const [numeroLacre, setNumeroLacre] = useState<string>('');
    const numeroLacreRef = useRef<HTMLInputElement>(null)
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const dispatch = useDispatch();
    const [selecionado, setSelecionado] = useState<number | string>('');
    const lacres = useSelector((state: RootState) => state.manifesto.manifesto).infMunDescarga
        .flatMap(mun => mun.infNFe).filter(nfe => nfe?.id?.toString() === idNFe.toString())
        .flatMap(ut => ut?.infUnidTransp).filter(f => f?.id.toString() === id.toString())
        .flatMap(ut => ut?.infUnidCarga ?? []).filter(i => i.id.toString() === idUndCarga.toString())
        .flatMap(l => l?.lacUnidCarga)
        ;

    const validaPreenchimento = () => {
        if (numeroLacre.trim() === "") {
            alertModal('Informe o número do lacre.');
            goToFocus(numeroLacreRef)
            return false;
        }

        if (lacres.find(item => item?.nLacre.toString() === numeroLacre.toString())) {
            alertModal(`O lacre ${numeroLacre.trim()} já foi adicionado.`);
            goToFocus(numeroLacreRef)
            return false;
        }
        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addLacreUnidadeCargaUnidadeTransporteNFe({
                idUnidadeCarga: idUndCarga,
                nfeId: idNFe,
                idUnidadeTransprte: id,
                lacre: {
                    id: getUuidV4(),
                    nLacre: numeroLacre
                }
            }))

            setNumeroLacre('');
            goToFocus(numeroLacreRef)
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id);
        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
            title: "Confirmação"
        });
        if (confirmed) {
            dispatch(removeLacreUnidadeCargaUnidadeTransporteNFe({
                idLacre: value.id,
                idUnidadeCarga: idUndCarga,
                idUnidadeTransprte: id,
                nfeId: idNFe
            }))
        }
        setSelecionado('');
    }

    const handleRemoverTodos = async () => {
        if (lacres.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos os lacres ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removeLacreUnidadeCargaUnidadeTransporteNFeTodos({
                    idUnidadeCarga: idUndCarga,
                    idUnidadeTransprte: id,
                    nfeId: idNFe
                }))
            }
        }
    }

    return (<Modal show={show} onHide={handleClose} centered backdrop='static' fullscreen={'xl-down'} scrollable >
        <Modal.Header closeButton className="py-2">
            <Modal.Title >
                Lacres
            </Modal.Title>

        </Modal.Header>
        <Modal.Body>
            <Row className="mb-3 ">
                <Col md>
                    <Form.Group controlId="nfe-utlc-numeroLacre">
                        <Form.Label>Número do lacre</Form.Label>
                        <Form.Control type="text" value={numeroLacre}
                            name="numeroLacre"

                            ref={numeroLacreRef}
                            placeholder="Digite o número + [Enter] para adicionar"
                            onChange={(e) => {
                                const el = (e.target as HTMLInputElement);
                                setNumeroLacre(el.value)
                            }}
                            onKeyUp={(e) => {
                                if (e.key === 'Enter') {
                                    handleAdd();
                                }
                            }}

                        />
                    </Form.Group>
                </Col>

            </Row>
            <JTable>
                <JTHead >
                    <tr>
                        <th className="text-center" style={{ width: '2.5rem' }}>
                            <ButtonTrash onClick={() => handleRemoverTodos()} />
                        </th>
                        <th>Número do lacre</th>
                    </tr>
                </JTHead>
                <JTBody>
                    {
                        lacres.map(item => {
                            return (<tr key={item?.id}
                                className={(item?.id?.toString()) === selecionado.toString() ? 'table-danger' : ''}>
                                <td className="text-center">
                                    <ButtonRemover
                                        onClick={() =>
                                            handleRemover({ id: item?.id ?? 0, title: item?.nLacre ?? '' })
                                        } />
                                </td>
                                <td>{item?.nLacre}</td>
                            </tr>)
                        })
                    }
                </JTBody>
            </JTable>
        </Modal.Body>
        <Modal.Footer className="py-2">
            <Button variant="secondary" onClick={handleClose} >
                <FontAwesomeIcon icon={faDoorClosed} /> Fechar
            </Button>
        </Modal.Footer>
        {ConfirmModal}
        {ModalMessageEl}

    </Modal>)
}

export default NFesUnidadeTranspUnidadeCargaLacres;